import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PageHeader: FunctionComponent<Props> = ({
    className = '',
    eyebrow,
    subtitle,
    testId = TEST_ID,
    title
}) => (
    <VerticalContainer className={`${className} ${styles.pageHeader}`} testId={testId}>
        <Wrapper className={styles.eyebrow}>{eyebrow}</Wrapper>

        <Wrapper className={styles.title}>{title}</Wrapper>

        <Wrapper className={styles.subtitle}>{subtitle}</Wrapper>
    </VerticalContainer>
);

export default PageHeader;
